import { useEffect, useRef, useState } from 'react';
import ApplyPromoIcon from './icons/ApplyPromoIcon';
import AppliedPromoIcon from './icons/AppliedPromoIcon';
import ClosePromoIcon from './icons/ClosePromoIcon';

export function ProductReturnSummary({
	cartData,
	applyCoupon,
	setCouponCode,
	coupon,
	couponCode,
	couponError,
	couponProcessing,
}) {
	const promoWrapperRef = useRef(null);
	const promoInputRef = useRef(null);
	const [promoApplied, setPromoApplied] = useState(false);
	const [disabled, setDisabled] = useState(false);

	useEffect(() => {
		if (coupon?.is_valid) {
			setPromoApplied(true);
			setDisabled(true);
			promoWrapperRef.current.classList.remove(
				'APPLY-promo-code-control'
			);
			promoWrapperRef.current.classList.add('APPLYED-promo-code-control');
		}
	}, [coupon]);

	useEffect(() => {
		const valueElements = document.querySelectorAll(
			'.ProductReturnSummary-value'
		);

		valueElements.forEach(el => {
			const text = el.textContent;
			const numericValue = parseFloat(text.replace(/[^0-9.-]+/g, ''));

			el.style.color = numericValue > 1 ? '#1F2632' : '#8F949B';
		});
	}, []);

	const promoCodeControl = e => {
		const value = e.target.value.trim();
		setCouponCode(value);

		if (promoWrapperRef.current) {
			if (value.length > 0) {
				promoWrapperRef.current.classList.add(
					'APPLY-promo-code-control'
				);
			} else {
				promoWrapperRef.current.classList.remove(
					'APPLY-promo-code-control'
				);
			}
		}
	};

	const handleApplyPromo = () => {
		if (couponCode.length > 0 && promoWrapperRef.current) {
			promoWrapperRef.current.classList.remove(
				'APPLY-promo-code-control'
			);
			promoWrapperRef.current.classList.add('APPLYED-promo-code-control');

			setPromoApplied(true);
			setDisabled(true);
			applyCoupon(true);
		}
	};

	const handleRemoveCoupon = () => {
		applyCoupon(false);
		setCouponCode('');
	};

	return (
		<ul
			className={`wp-checkout-ProductReturnSummary-list ${promoApplied ? 'promo-applied' : ''}`}
		>
			<li className="wp-checkout-ProductReturnSummary-list-item">
				<span className="wp-checkout-font-base ProductReturnSummary-title">
					Subtotal
				</span>
				<span className="wp-checkout-font-base ProductReturnSummary-value">
					${(+cartData?.subtotal)?.toFixed(2)}
				</span>
			</li>
			<li
				className="wp-checkout-ProductReturnSummary-list-item promo-code-control"
				ref={promoWrapperRef}
			>
				<span className="promo-code-icon line-height-0">
					{promoApplied ? <ApplyPromoIcon /> : <AppliedPromoIcon />}
				</span>
				<span className="promo-code-control">
					<input
						ref={promoInputRef}
						className="wp-checkout-font-base promo-code-input-control"
						type="text"
						placeholder="Add Promo Code"
						value={couponCode}
						onChange={promoCodeControl}
						disabled={disabled}
					/>
				</span>

				<button
					className="wp-checkout-font-sm promo-code-submit"
					onClick={handleApplyPromo}
					disabled={promoApplied}
				>
					{promoApplied ? 'APPLIED' : 'APPLY'}
				</button>
				{promoApplied ? (
					<button
						onClick={handleRemoveCoupon}
						className="wp-promo-btn-close-bnt-divider"
					>
						<span className="wp-promo-code-close-icon">
							<ClosePromoIcon />
						</span>
					</button>
				) : (
					''
				)}
			</li>

			{promoApplied && (
				<li className="wp-checkout-ProductReturnSummary-list-item">
					<span className="wp-checkout-font-base ProductReturnSummary-title">
						{cartData?.coupons?.amount ?? 0}% Discount
					</span>
					<span className="wp-checkout-font-base ProductReturnSummary-value">
						-${(+cartData?.discounted_amount)?.toFixed(2)}
					</span>
				</li>
			)}

			{/* <li className="wp-checkout-ProductReturnSummary-list-item">
				<span className="wp-checkout-font-base ProductReturnSummary-title">
					Tax
				</span>
				<span className="wp-checkout-font-base ProductReturnSummary-value">
					${cartData?.tax}
				</span>
			</li> */}
			<li className={`wp-checkout-ProductReturnSummary-list-item`}>
				<span className="wp-checkout-font-exl ProductReturnSummary-title">
					Total
				</span>
				<span className="wp-checkout-font-exl ProductReturnSummary-value">
					${(+cartData?.total)?.toFixed(2)}
				</span>
			</li>
		</ul>
	);
}
